import type { SubmissionErrorCode } from '@flarecode/shared';
import { ApiError } from './api';

const MESSAGES: Record<SubmissionErrorCode, string> = {
  submission_too_large: 'Your source is too large (64 KB max). Trim it down and try again.',
  empty_source: 'Your editor is empty. Write some code first.',
  invalid_language: 'Unknown language selection.',
  language_not_supported_yet:
    "That language isn't wired up yet. Python, JavaScript, and TypeScript work today.",
  problem_not_found: "We couldn't find that problem.",
  unauthorized: 'You need to be signed in to submit.',
  invalid_json: 'We sent a malformed request. Try again.',
  rate_limited: 'Too many submissions. Wait about a minute before submitting again.',
};

export function submissionErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code && err.code in MESSAGES) {
      return MESSAGES[err.code as SubmissionErrorCode];
    }
    if (err.status === 0 || err.status >= 500) {
      return 'Something went wrong on our end. Please try again in a moment.';
    }
    return err.message || 'Request failed.';
  }
  return 'Network error. Check your connection and try again.';
}
